export enum Routes {
	DonationForm = 'donation-form',
	SelectCountry = 'select-country'
}
